import React from "react";

import { Badge, Icon } from "@culturehq/components";

import { BodyTag } from "chq";

import { useQueryString } from "app/context";
import { useExpand } from "app/hooks";
import { getQueryStringKey } from "app/utils";

import { getIcon } from "constants/tagsTypes";

type TagProps = {
  tag: BodyTag;
  handleTagClick: (tag: BodyTag) => void;
};

const Tag: React.FC<TagProps> = ({ tag, handleTagClick }) => {
  const icon = getIcon(tag.type);

  if (!tag.name) return <></>;

  return (
    <Badge key={`${tag.type}-${tag.entityId}`} onClick={() => handleTagClick(tag)}>
      <Icon icon={icon} className="category-icon" />
      {tag.name}
    </Badge>
  );
};

type BodyTagsProps = {
  hideLinks?: boolean;
  isPreview?: boolean;
  landingPage?: boolean;
  numberOfTagsToshow?: number;
  showTags?: boolean;
  showDefaultTag?: boolean;
  tags: BodyTag[];
};

const BodyTags: React.FC<BodyTagsProps> = ({
  hideLinks,
  isPreview,
  landingPage,
  numberOfTagsToshow = 5,
  showTags = true,
  showDefaultTag,
  tags
}) => {
  const [expanded, onExpand] = useExpand();
  const { onToggleQueryStringValue } = useQueryString();

  const handleTagClick = (tag: BodyTag) => {
    if (!hideLinks && !isPreview && onToggleQueryStringValue) {
      onToggleQueryStringValue(getQueryStringKey(tag.type), tag.entityId);
    }
  };

  return (
    <div className="chq-ffd-tags">
      <div className="chq-ffd-tags__child">
        {expanded ? (
          <>
            {tags.map((tag: BodyTag) => (
              <Tag key={`${tag.type}-${tag.entityId}`} tag={tag} handleTagClick={handleTagClick} />
            ))}
            <div className="ExpandOptions__minus-option">
              <span
                onClick={event => {
                  event.stopPropagation();
                  onExpand(false);
                }}
              >
                <Icon icon="minus" />
                {" "}
                show less
              </span>
            </div>
          </>
        ) : (
          <>
            {tags.slice(0, numberOfTagsToshow).map((tag: BodyTag) => (
              <Tag key={`${tag.type}-${tag.entityId}`} tag={tag} handleTagClick={handleTagClick} />
            ))}
            {tags.length > numberOfTagsToshow && (
              <div className="ExpandOptions__plus-option">
                <span
                  onClick={event => {
                    event.stopPropagation();
                    onExpand(true);
                  }}
                >
                  <Icon icon="plus" />
                  {" "}
                  {tags.length - numberOfTagsToshow}
                </span>
              </div>
            )}
          </>
        )}
        {showDefaultTag && showTags && tags && !landingPage && tags.length === 0 && (
          <Badge className="Everyone--Tag">
            <Icon icon="global" className="category-icon" />
            Everyone
          </Badge>
        )}
      </div>
    </div>
  );
};

export default BodyTags;
